import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-apps',
	templateUrl: './apps.component.html',
	styleUrls: ['./apps.component.scss'],
})
export class AppsComponent implements OnInit {
	constructor(private router: Router, private title: Title, private platform: Platform, private locale: LocaleService) {}

	ios: boolean = this.platform.IOS;
	android: boolean = this.platform.ANDROID;
	countdown: number = 3;

	ngOnInit(): void {
		this.title.setTitle('Apps | Kurd Shopping');

		let timer = setInterval(() => {
			this.countdown = this.countdown - 1;

			if (this.countdown === 0) {
				clearInterval(timer);

				const userAgent = window.navigator.userAgent.toLowerCase();

				if (/Android/i.test(navigator.userAgent)) {
					const appPackage = 'com.opaxlabs.kurdshopping';
					const playStoreURL = `market://details?id=${appPackage}`;
					window['location']['href'] = playStoreURL;
				} else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
					const appID = '537659933'; // Replace with your app's unique identifier
					const appStoreUrl = `itms-apps://itunes.apple.com/app/${appID}`;
					window.location.href = appStoreUrl;
				} else if (/HarmonyOS/i.test(navigator.userAgent)) {
					window['location']['href'] = 'https://appgallery.huawei.com/#/app/C100966239';
				}
				window.location.href = '/';
			}
		}, 1000);
	}
}
